import { render, staticRenderFns } from "./IssueDrawer.vue?vue&type=template&id=59349d37&scoped=true"
import script from "./IssueDrawer.vue?vue&type=script&lang=js"
export * from "./IssueDrawer.vue?vue&type=script&lang=js"
import style0 from "./IssueDrawer.vue?vue&type=style&index=0&id=59349d37&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59349d37",
  null
  
)

export default component.exports